module.exports = __webpack_public_path__ + "img/20200705_122225.f2bf288b.jpg";